import { PropsWithChildren, ReactNode } from "react";

import { SxProps, Theme } from "@mui/material/styles";
import { ClassNameMap } from "@mui/styles";

import { InternalClasses } from "../helpers";

import { NonGenericBaseFormFieldProps } from "@/types/baseFormField";
import { InputVibe } from "@/types/mui";

export type InputLabelBaseClasses =
  | "container"
  | "footerText"
  | "errorText"
  | "helperText"
  | "emptyFooter"
  | "header"
  | "headerRight"
  | "labelContainer"
  | "labelNeutral"
  | "labelForm";

const PREFIX = "ZeffyInputLabel";

export const zeffyInputLabelClasses: InternalClasses<typeof PREFIX, InputLabelBaseClasses> = {
  container: `${PREFIX}-container`,
  header: `${PREFIX}-header`,
  labelContainer: `${PREFIX}-labelContainer`,
  labelNeutral: `${PREFIX}-labelNeutral`,
  labelForm: `${PREFIX}-labelForm`,
  headerRight: `${PREFIX}-headerRight`,
  footerText: `${PREFIX}-footerText`,
  helperText: `${PREFIX}-helperText`,
  errorText: `${PREFIX}-errorText`,
  emptyFooter: `${PREFIX}-emptyFooter`,
};

export interface InputLabelProps
  extends Pick<NonGenericBaseFormFieldProps, "errorMessage" | "label">,
    PropsWithChildren<unknown> {
  classes?: Partial<ClassNameMap<InputLabelBaseClasses>>;
  className?: string;
  vibe?: InputVibe;
  helperText?: string | React.ReactNode;
  headerRight?: ReactNode;
  tooltipText?: string;
  size?: "medium" | "small";
  sx?: SxProps<Theme>;
  "data-test"?: string;
}

export type InputLabelSsrProps = InputLabelProps & {
  forwardedRef?: React.Ref<HTMLDivElement>;
};
